export default __webpack_public_path__ + "static/tdcxQR-ba55f849deee96fe7e7da3cd21cad029.jpg";